export default function ChannelCircle({size,color}){
  const dim = size;
  const cc = color;

  return (
    <div style={{background:cc,margin:2, borderRadius:55, width:dim, height:dim,border:'1px solid #ccc',}}/>

  )
}
